export var CrudQueryParam = /*#__PURE__*/function (CrudQueryParam) {
  CrudQueryParam["fields"] = "fields";
  CrudQueryParam["search"] = "search";
  CrudQueryParam["filter"] = "filter";
  CrudQueryParam["or"] = "or";
  CrudQueryParam["join"] = "join";
  CrudQueryParam["sort"] = "sort";
  CrudQueryParam["limit"] = "limit";
  CrudQueryParam["offset"] = "offset";
  CrudQueryParam["page"] = "page";
  CrudQueryParam["cache"] = "cache";
  CrudQueryParam["includeDeleted"] = "includeDeleted";
  return CrudQueryParam;
}(CrudQueryParam || {});
export const crudParamNamesMap = {
  fields: 'fields',
  search: 's',
  filter: 'filter',
  or: 'or',
  join: 'join',
  sort: 'sort',
  limit: 'limit',
  offset: 'offset',
  page: 'page',
  cache: 'cache',
  includeDeleted: 'include_deleted'
};
export const CrudQueryBuilderDefaultOptions = {
  delim: '||',
  delimStr: ',',
  paramNamesMap: crudParamNamesMap
};